#import '../queries/UserDetails.graphql'
mutation CreateTeacher($userData: UserInput!) {
  createTeacher(userData: $userData) {
    ok
    errors
    user {
      ...userDetails
    }
  }
}
